import axios from "axios";
import { ELVIS_URL, API2_HOST } from 'helpers/urlHelper';

axios.defaults.withCredentials = true;

const groupByConversationToArray = items => {
    const map = items.reduce((acc, item) => {
        const key = item.conversationId;
        if (!acc[key]) acc[key] = [];
        acc[key].unshift(item);
        return acc;
    }, {});
    return Object.keys(map).map(id => ({ id, messages: map[id].sort((a, b) => a.id - b.id) }));
};

const fetchHistory = async () => {
    try {
        const res = await axios(`${ELVIS_URL}/api/ai/my-history`);
        if (res?.status != 200) throw new Error(`Fetch failed: ${res.status}`);
        const data = res.data;

        return groupByConversationToArray(data);
    } catch (err) {
        console.error(err);
    }
};

const askElvis = async newMessage => {
    return await axios.post(`${ELVIS_URL}/api/ai/ask`, newMessage);
}

const searchChats = async query => {
    try {
        return await axios.get(`${ELVIS_URL}/api/ai/search-chats?q=${encodeURIComponent(query)}`);
    } catch (err) {
        console.error(err);
        throw (err);
    }
}

const rateMessage = async (id, rating) => {
    try {
        return await axios.post(`${ELVIS_URL}/api/ai/rate-answer`, { id, rating });
    }
    catch (err) {
        console.error(err);
        throw (err);
    }
}

const rateMessageStar = async (id, rating) => {
    try {
        return await axios.post(`${ELVIS_URL}/api/ai/rate-answer-star`, { id, rating });
    }
    catch (err) {
        console.error(err);
        throw (err);
    }
}

const getChatById = async id => {
    try {
        const res = await axios.get(`${ELVIS_URL}/api/ai/get-chat?id=${id}`);
        return groupByConversationToArray(res.data);
    } catch (err) {
        console.error(err);
        throw err;
    }
}

const reportChatById = async id => {
    try {
        const res = await axios.get(`${API2_HOST}/report-elvis-message/report-answer?id=${id}`);
        return res.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
}

const fetchConvos = async (filters = null) => {
    try {
        return await axios.post(`${ELVIS_URL}/api/ai/conversations`, {
            ...filters,
            users: filters.users.map(x => x.userId)
        });
    }
    catch (err) {
        console.error(err);
        throw (err);
    }
}

export { fetchHistory, askElvis, searchChats, getChatById, rateMessage, rateMessageStar, reportChatById, fetchConvos }
